/******************************************************************
 * This file is for render-blocking scripts. It loads in priority.
 *****************************************************************/
import jQuery from 'jquery';
import 'jquery-modal';
import _ from 'lodash-es';

// Third-party libraries
// import protip from 'protip';
// import WOW from 'wowjs/dist/wow';
// import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
// import { cookiesEnabled } from '@shopify/theme-cart';

// Core modules
import { breakpoints } from '@coreJS/breakpoints';
import { animations } from '@coreJS/animations';
import pagesViewed from '@coreJS/page-view';
import policies from '@coreJS/policies';
// import firstTimeUser from '@coreJS/first-time-user';

// Global sections
import initHeader from '@sectionsJS/header';
import footer from '@sectionsJS/footer';
import { sliderCart } from '@sectionsJS/slider-cart';
// import landingModal from '@sectionsJS/landing-modal';

// Init global variables
window.theme = window.theme || {};
const $ = jQuery.noConflict();
window.$ = $;
window.jQuery = jQuery;
window.Shopify = window.Shopify || {};
window._ = _;

// Disable console logging on production
if ((typeof window.Shopify.theme !== 'undefined' && Shopify.theme.role !== 'unpublished') && window.Shopify.shop !== 'astr-the-label-dev.myshopify.com' && window.Shopify.shop !== 'staging-astr-the-label.myshopify.com' && window.Shopify.shop !== 'localhost:3000' && !window.location.href.includes('debug=1')) {
  console.log = () => {};
}

const refreshElements = () => {
  window.dispatchEvent(new Event('resize'));
  window.dispatchEvent(new Event('scroll'));
};

document.addEventListener('DOMContentLoaded', async () => {
  // Save Page for product filtering
  window.localStorage.setItem('previous-page', window.localStorage.getItem('current-page'));
  window.localStorage.setItem('current-page', document.location.href);

  // Init Protip (tooltip) https://github.com/wintercounter/Protip
  // Example: <a href="#bar" class="protip" data-protip-title="You must be at least 18!">
  // $.protip({
  //   namespace: 'protip',
  // });

  // Remove the annoying preview bar
  // if (window.location.origin.indexOf('myshopify.com') !== -1 || window.location.origin.indexOf('localhost') !== -1) {
  //   $('#preview-bar-iframe').remove();
  // }

  window.setTimeout(() => {
    refreshElements();
  });

  // Init core modules
  breakpoints();
  animations();
  pagesViewed();
  policies();
  // firstTimeUser();

  // Init Global sections
  initHeader();
  footer();
  await sliderCart();
});
